import React from 'react';
import { HeroContent } from './HeroContent';
import { HeroDescription } from './HeroDescription';
import { HeroLogo } from './HeroLogo';
import { HeroBackground } from './HeroBackground';
import { MobileRightImage, MobileLeftImage } from './MobileImages';

const WhoWeAreSection = () => {
  return (
    <section
      className="position-relative w-100 bg-light"
      style={{ minHeight: '599px' }}
    >
      {/* Background images */}
      <HeroBackground />

      {/* Desktop centered content */}
      <div
        className="position-absolute d-none d-md-flex flex-column align-items-center"
        style={{
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '100%',
          maxWidth: '712px',
          padding: '20px',
          gap: '16px',
          zIndex: '2'
        }}
      >
        <HeroContent />
        <HeroDescription />
        <HeroLogo />
      </div>

      {/* Mobile stacked layout */}
      <div className="d-block d-md-none container-fluid py-4" style={{ zIndex: '2' }}>
        <div className="row justify-content-center">
          <div className="col-12" style={{ padding: '0'}}>
            {/* Right hand image first on mobile */}
            <MobileRightImage />

            {/* Content in the middle */}
            <div className="px-3">
              <HeroContent />
              <HeroDescription />
              <HeroLogo />
            </div>

            {/* Left hand image last on mobile */}
            <MobileLeftImage />
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhoWeAreSection;
